import Checkbox from 'components/Checkbox';
import filters from 'data/filters';
import { TOP_FILTERS } from 'modules/common/Popovers/MoreFiltersPopover/hooks/useTopFilters';
import React from 'react';

const CSS = require('./TopFilters.module.scss');

interface TopFilterProps {
  selectedCategories: string[];
  onCategoryToggle: (value: string) => void;
}

function TopFilters({ selectedCategories, onCategoryToggle }: TopFilterProps) {
  return (
    <ul className={CSS.TopFilters}>
      {filters
        .filter((filter) => TOP_FILTERS.includes(filter.uid))
        .sort((filter) => filter.order)
        .map((filter) => {
          const selectedSubcategories = selectedCategories.find(
            (selCategory) => selCategory === filter.uid,
          );
          const onFilterClick = (e) => onCategoryToggle(e.currentTarget.value);
          return (
            <li key={filter.name} className={CSS.TopFiltersItem}>
              <Checkbox
                className={CSS.Filter}
                iconClassName={CSS.FilterIcon}
                value={filter.uid}
                onChange={onFilterClick}
                checked={
                  !!selectedSubcategories &&
                  selectedSubcategories.includes(filter.uid)
                }
              >
                {filter.name}
              </Checkbox>
            </li>
          );
        })}
    </ul>
  );
}

export default TopFilters;
